import { atom } from 'recoil';

export const instancesAtom = atom({
  key: 'instancesAtom', 
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});